import { render, staticRenderFns } from "./syncElButton.vue?vue&type=template&id=3fab53a4&"
import script from "./syncElButton.vue?vue&type=script&lang=js&"
export * from "./syncElButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports